import React, { useRef, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import ModalWhatsAppAuth from "./ModalWhatsAppAuth";
import ModalError from "./ModalError";
import { useWhatsAppAuthContext } from "~/contexts/WhatsAppAuthContext";

const WhatsAppLoginButton = ({
	onError,
	language,
	className,
	style,
	disabled = false,
	onLoadingChange,
	successRoute,
	reloadOnSuccess = false,
	label,
	goBackRouteProps,
	checkoutInformation = null,
	schedulingServicePackage = null,
	questions = [],
	observation = "",
	onFinalizeAppointment = null,
	observationTextField = null,
	setErrorObservation = null,
	onStartLoading = null,
	checkoutLoading = false,
	showCustomLogin = false,
	goToFallbackBusinessPage,
	business,
	onCustomLoginClose,
	authContext = "booking",
}) => {
	const { t } = useTranslation();
	const history = useHistory();
	const location = useLocation();
	const classes = useStyles();
	const hasAutoStartedRef = useRef(false);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const showLoginGoogle = !business ? false : business?.gmailClient;

	const {
		authStatus,
		isLoading,
		stopPolling,
		requestAuthCredential,
		setShowModal,
		reset,
		lastCode,
		handleFinalizeAuth,
		showModal
	} = useWhatsAppAuthContext();

	useEffect(() => {
		if (onLoadingChange) {
			onLoadingChange(isLoading);
		}
	}, [isLoading, onLoadingChange]);

	useEffect(() => {
		return () => {
			stopPolling();
		};
	}, [stopPolling]);

	const loginWithWhatsApp = async () => {
		try {
			const showSuccessModal = !!checkoutInformation;
			
			await requestAuthCredential({
				language,
				onError,
				redirectRoute: successRoute,
				reloadOnSuccess,
				goBackRouteProps,
				showSuccessModal,
				authContext,
			});
		} catch (error) {
			console.error("Erro ao fazer login com WhatsApp:", error);
		}
	};

	return (
		<>
			{ !showCustomLogin &&  (
				<Button className={className || classes.button} style={{...style, textTransform: 'none'}} onClick={loginWithWhatsApp} disabled={disabled}>
					<WhatsAppIcon style={{ paddingLeft: "2px" }} />
					<span style={{ flexGrow: 1, textAlign: "center", marginRight: "24px" }}>{ label || t("whatsApp login soon")}</span>
				</Button>
			)}

			<ModalWhatsAppAuth
				open={showCustomLogin || showModal}
				onClose={() => {
					stopPolling();
					setShowModal(false);
					hasAutoStartedRef.current = false;
					localStorage.removeItem("@prit-web/lastCode");
					reset();
					if (location?.state?.whatsappAuthPending) {
						const { whatsappAuthPending, authCode, goBackRoute, goBackRouteProps, ...restState } = location.state;
						history.replace(location.pathname, restState);
					}
					if (onCustomLoginClose) onCustomLoginClose();
				}}
				status={authStatus}
				lastCode={lastCode}
				isLoading={isLoading}
				handleFinalizeAuth={handleFinalizeAuth}
				checkoutInformation={checkoutInformation}
				schedulingServicePackage={schedulingServicePackage}
				questions={questions}
				observation={observation}
				onFinalizeAppointment={onFinalizeAppointment}
				observationTextField={observationTextField}
				setErrorObservation={setErrorObservation}
				onStartLoading={onStartLoading}
				checkoutLoading={checkoutLoading}
				loginWithWhatsApp={loginWithWhatsApp}
				showCustomLogin={showCustomLogin}
				showLoginGoogle={showLoginGoogle}
				successRoute={successRoute}
				goToFallbackBusinessPage={goToFallbackBusinessPage}
			/>

			<ModalError
				open={showErrorModal}
				onClose={() => {
					setShowErrorModal(false);
					setErrorMessage("");
				}}
				message={errorMessage}
				onRetry={() => {
					setShowErrorModal(false);
					setErrorMessage("");
					window.location.reload();
				}}
			/>
		</>
	);
};

export default WhatsAppLoginButton;
